import React from 'react'
import { PeripheralPrinter } from "utils/PeripheralManager"

const MaintenanceComponent = ({device}: {device: USBPrinter}) => {
  return (
    <>
    </>
  )
}

function base64ToArrayBuffer(base64: string) {
  var binaryString = atob(base64);
  var bytes = new Uint8Array(binaryString.length);
  for (var i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

class USBPrinter implements PeripheralPrinter<USBPrinter> {
  device: USBDevice

  getDriverName = () => 'USBPrinter'

  setConfig = async (data: any) => {

  };

  connect = async (data: any) => {
    if (data && navigator.usb.getDevices) {
      // https://googlechrome.github.io/samples/web-bluetooth/watch-advertisements-and-connect-async-await.html
      this.device = (await navigator.usb.getDevices()).find(it => it.serialNumber === data.id)
      console.log("found device with id: ", data.id, this.device)
    } else {
      this.device = await navigator.usb.requestDevice({ filters: [] });
      return { id: this.device.serialNumber, name: this.device.productName }  
    }
  }

  disconnect = async () => {
    this.device = null
  }

  isConnected = async () => {
    return !!this.device
  }

  print = async (mediatype: string, _payload: string) => { 
    await this.device.open();
    try {
      await this.device.selectConfiguration(1);
      await this.device.claimInterface(0);
      await this.device.transferOut(
        this.device.configuration.interfaces[0].alternate.endpoints.find(obj => obj.direction === 'out').endpointNumber,
        base64ToArrayBuffer(_payload),
      );
    } finally {      
      await this.device.close();
    }
  }

  getMaintenanceComponent = () => MaintenanceComponent
}

export default USBPrinter